import { useTheme } from 'next-themes'

/*
* Get the provider icon URL
This hook is used to get the provider icon URL based on the provider name.
*/
export const useGetProviderIconUrl = (provider: string, type: 'icon' | 'logo') => {
  const { theme } = useTheme()
  const isDark = theme === 'dark'
  const providerUrl = `https://chaine-images.s3.amazonaws.com/product-app-images/${
    type === 'logo' ? 'logos' : 'app-icons'
  }/${provider}-${isDark ? 'dark' : 'light'}.${type === 'icon' ? 'png' : 'svg'}`
  return providerUrl
}
